import classNames from 'classnames';
import * as React from 'react';

import { makeGridPopupContainer } from '../../containers/GridPopup/GridPopup';
import { Bem } from '../../service/Bem/Bem';
import { getRetargetingConditions } from '../../service/RetargetingHelpers/RetargetingHelpers';
import { CopyTooltipStatus, RetargetingConditionRule } from '../../typings/domain';
import {
    RetargetingRulesInfoTooltip,
    RetargetingRulesInfoTooltipProps
} from '../RetargetingRulesInfoTooltip/RetargetingRulesInfoTooltip';

import './RetargetingRulesInfo.css';

export interface RetargetingRulesInfoProps {
    conditionRules: Array<RetargetingConditionRule>;
    copyTooltipStatus: CopyTooltipStatus;
    onCopy: (description: string) => void;
    onPopupOpen: () => void;
}

const GridPopupContainer = makeGridPopupContainer<RetargetingRulesInfoTooltipProps>(RetargetingRulesInfoTooltip);

export class RetargetingRulesInfo extends React.PureComponent<RetargetingRulesInfoProps> {
    render() {
        const { conditionRules, copyTooltipStatus, onPopupOpen } = this.props;

        return (
            <div className={classNames(Bem.cls('retargeting-rules-info'))}>
                <div className={Bem.cls('retargeting-rules-info', 'description')}>
                    {getRetargetingConditions(conditionRules, false)}
                </div>
                <GridPopupContainer
                    onPopupOpen={onPopupOpen}
                    conditionRules={conditionRules}
                    copyTooltipStatus={copyTooltipStatus}
                    onCopy={this.onCopyClick}
                />
            </div>
        );
    }

    private onCopyClick = () => {
        const { conditionRules } = this.props;
        const text = getRetargetingConditions(conditionRules, true);

        this.props.onCopy(text);
    };
}
